<form [formGroup]="formGroup">
  <div class="criteria-type-header">
    <span class="criteria-type-label">CRITERIA TYPE</span>
    <mat-button-toggle-group *ngIf="canCompareField()"
                             [value]="isCompareFieldMode ? 'FIELD' : 'VALUE'"
                             (change)="toggleCompareFieldMode($event.value)"
                             hideSingleSelectionIndicator="true"
                             class="compare-field-toggle">
      <mat-button-toggle value="VALUE">VALUE</mat-button-toggle>
      <mat-button-toggle value="FIELD">COMPARE FIELD</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-paired-autocomplete #fieldName [selectedFieldControl]="fieldNameControl"
                           [secondaryEntityControl]="secondaryDescriptorControl"
                           [primaryEntity]="primaryEntity"
                           [componentId]="'criteria-fieldName'" (inputCleared)="clearFieldName()"
                           [entitiesOptions]="entitiesOptions"
                           [inputRequired]="true"
                           [overlayPositioningConfig]="overlayPositioningConfig"
  >
  </app-paired-autocomplete>
  <aside>
    <section *ngIf="selectedFieldType !== 'ADDRESS'">
      <form [formGroup]="formGroup" class="criteria-grid-2">
        <mat-select [panelClass]="'extra-height'" class="full-width" formControlName="operator">
          <mat-option *ngFor="let op of operators" value="{{op.value}}">{{op.label}}</mat-option>
        </mat-select>
        <app-compare-criteria *ngIf="isCompareFieldMode"
                              [primaryEntity]="primaryEntity"
                              [entitiesOptions]="entitiesOptions"
                              [selectedFieldType]="selectedFieldType"
                              [selectedFieldToOneType]="selectedFieldToOneType"
                              [sourceFieldName]="fieldNameControl.value"
                              [sourceSecondaryDescriptor]="secondaryDescriptorControl.value"
                              [overlayPositioningConfig]="overlayPositioningConfig"
                              [initialValue]="isCompareFieldMode ? criteria.value : null"
                              (fieldSelected)="onCompareFieldSelected($event)">
        </app-compare-criteria>
        <span *ngIf="!isCompareFieldMode && (formGroup.get('operator').value === 'in' || formGroup.get('operator').value === 'notIn') && valuesReady; else notInOperator">
          <app-chip-list-autocomplete #fieldValue *ngIf="fieldTypeControl?.value === 'TO_MANY'; else notToManyChipList"
                                      [valueControl]="valueControl"></app-chip-list-autocomplete>

          <ng-template #notToManyChipList>
            <mat-chip-grid #chipList formControlName="value">
                <mat-chip-row *ngFor="let val of formGroup.get('value').value"
                              removable="true" (removed)="removeInValue(val)" matTooltipPosition="above"
                              [matTooltip]="val" [matTooltipDisabled]="!isTruncated(chipText)"
                              matTooltipClass="scrollable-tooltip">
                  <span class="chip-text" #chipText>{{val}}</span>
                  <mat-icon matChipRemove>close</mat-icon>
                </mat-chip-row>
              <input placeholder="value" [matChipInputFor]="chipList" [matChipInputAddOnBlur]="true"
                     [matChipInputSeparatorKeyCodes]="[13,188]" (matChipInputTokenEnd)="addInValue($event)">
            </mat-chip-grid>
          </ng-template>
        </span>
        <ng-template #notInOperator>
          <ng-container *ngIf="!isCompareFieldMode">
            <ng-container *ngIf="formGroup.get('operator').value === 'isNull' ||
            formGroup.get('operator').value === 'isNotNull' ||
             formGroup.get('operator').value === 'hasSome' ||
              formGroup.get('operator').value === 'hasNone';
            else showInput">
            </ng-container>
            <ng-template #showInput>
              <ng-container>
                <div *ngIf="formGroup.get('operator').value === 'within' || formGroup.get('operator').value === 'notWithin'; else otherOperators" class="date-grid">
                  <mat-select class="full-width" formControlName="timeOperator" placeholder="Choose period..." required>
                    <mat-option *ngFor="let o of timeOperators" [value]="o">
                      {{timeOperator[o]}}
                    </mat-option>
                  </mat-select>
                  <input type="number" formControlName="notWithinValue" type="number" min="1" required>
                  <mat-select class="full-width" formControlName="unitOfTime" placeholder="Choose units..." required>
                    <mat-option *ngFor="let o of unitsOfTime" [value]="o">
                      {{unitsTime[o]}}
                    </mat-option>
                  </mat-select>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #otherOperators>
              <label [ngSwitch]="selectedFieldType">
                  <input *ngSwitchCase="'STRING'" type="text" formControlName="value"
                         [placeholder]="DataRulesService.isSelectedEntitySearchEntity(this.primaryEntity) ? 'Enter text...' : 'Empty String'"
                         [required]="DataRulesService.isSelectedEntitySearchEntity(this.primaryEntity)">
                <input *ngSwitchCase="'INTEGER'" type="number" formControlName="value" placeholder="Enter a number..." required>
                <input *ngSwitchCase="'DOUBLE'" type="number" formControlName="value" placeholder="Enter a number..." required>
                <input *ngSwitchCase="'FLOAT'" type="number" formControlName="value" placeholder="Enter a number..." required>
                <input *ngSwitchCase="'BIG_DECIMAL'" type="number" formControlName="value" placeholder="Enter a number..." required>
                <div *ngSwitchCase="'DATE'" class="datepicker-container">
                  <input matInput
                         id="stopDate"
                         [matDatepicker]="picker_date_criteria"
                         placeholder="dd/mm/yyyy"
                         (click)="picker_date_criteria.open()"
                         formControlName="value"
                         required>

                  <mat-datepicker-toggle matSuffix [for]="picker_date_criteria"></mat-datepicker-toggle>
                  <mat-datepicker #picker_date_criteria></mat-datepicker>
                </div>
                <input class="kyloe-checkbox" *ngSwitchCase="'BOOLEAN'" type="checkbox" formControlName="value">
                <app-autocomplete *ngSwitchDefault #fieldValue [selectedOptionControl]="valueControl"
                                  [componentId]="'criteria-fieldValue'"
                                  [placeholder]="toManyPlaceholderText ? toManyPlaceholderText : 'Enter a value...'"></app-autocomplete>
              </label>
            </ng-template>
          </ng-container>
        </ng-template>
      </form>
    </section>

    <app-address-criteria *ngIf="selectedFieldType === 'ADDRESS'"
                          [formGroup]="formGroup"
                          [operators]="operators"
                          [valuesReady]="valuesReady"
                          [addressData]="criteria.value"
                          [primaryEntity]="primaryEntity">
    </app-address-criteria>

  </aside>
  <!--  {{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}-->
</form>
